import { useLanguage } from "../lib/i18n";
import { Logo } from "../components/Logo";

export function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="relative overflow-hidden bg-[#08090B] pt-24" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex flex-col items-center gap-4 border-t border-white/10 pt-14 text-center">
          <Logo size={40} />
          <p className="max-w-md font-inter text-sm text-hars-muted">{t.footerTagline}</p>
        </div>
      </div>

      <div className="relative mt-8 flex justify-center overflow-hidden">
        <h2
          className="heading text-outline text-outline-hover translate-y-[20%] cursor-default whitespace-nowrap text-[26vw] leading-none transition-colors duration-500"
          data-cursor
        >
          HARSPRO
        </h2>
      </div>

      <div className="border-t border-white/5 py-6 text-center font-inter text-xs text-hars-muted">
        © {new Date().getFullYear()} HARSPRO. {t.rights}
      </div>
    </footer>
  );
}
